import { rootApi } from '../rootApi';
import { OrgSearchProps } from './search.types';
import { PaginatedResponse } from '../api.types';
import { ICompanyProfile } from '../connections/connections.types';

export const searchApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    searchActiveOrganisations: builder.query<PaginatedResponse<ICompanyProfile>, OrgSearchProps>({
      query: (data) => ({
        url: `/global/${data.tenant}?search_query=${data.searchQuery}&page=${data.page}&per_page=${data.per_page}${data.excludeConnections ? `&exclude_connections=${data.excludeConnections}` : ''}`,
      }),
    }),
  }),
});

export const { useLazySearchActiveOrganisationsQuery, useSearchActiveOrganisationsQuery } =
  searchApi;
